import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "ui/components/card";
import { Separator } from "ui/components/separator";
import { Icon } from "components";
import AvatarDisplay from "components/avatar/display";
import { CALENDAR, CIRCLE_ALERT, TAG, USER } from "icons/src";
import { formatDateForDisplay, formatLabel } from "utils/utils";
import { formatName } from "utils/index";

export default function TicketDetailsSidebar({
  assigned_to,
  priority,
  type,
  due_date,
  date_created,
  user_created,
}) {
  const priorityColors = {
    low: "text-blue-500",
    medium: "text-yellow-500",
    high: "text-orange-500",
    urgent: "text-red-500",
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Details</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <Icon icon={USER} className="size-5" />
            <div className="flex-1">
              <p className="text-sm text-gray-500">Assigned to</p>
              <div className="flex items-center gap-2 mt-1">
                {assigned_to ? (
                  <>
                    <AvatarDisplay className="w-8 h-8" user={assigned_to} />
                    <p className="font-medium">{formatName(assigned_to)}</p>
                  </>
                ) : (
                  <p className="font-medium text-gray-400">Unassigned</p>
                )}
              </div>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <Icon icon={CIRCLE_ALERT} className="size-5" />
            <div className="flex-1">
              <p className="text-sm text-gray-500">Priority</p>
              <p className={`font-medium capitalize ${priorityColors[priority?.toLowerCase?.()] || ""}`}>
                {priority || "Not set"}
              </p>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <Icon icon={TAG} className="size-5" />
            <div className="flex-1">
              <p className="text-sm text-gray-500">Type</p>
              <p className="font-medium">{type ? formatLabel(type) : "Not set"}</p>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <Icon icon={CALENDAR} className="size-5" />
            <div className="flex-1">
              <p className="text-sm text-gray-500">Due Date</p>
              <p className="font-medium">{due_date ? formatDateForDisplay(due_date) : "Not set"}</p>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <Icon icon={CALENDAR} className="size-5" />
            <div className="flex-1">
              <p className="text-sm text-gray-500">Created on</p>
              <p className="font-medium">{date_created ? formatDateForDisplay(date_created) : "Not set"}</p>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <Icon icon={USER} className="size-5" />
            <div className="flex-1">
              <p className="text-sm text-gray-500">Created By</p>
              <div className="flex items-center gap-2 mt-1">
                {user_created ? (
                  <>
                    <AvatarDisplay className="w-8 h-8" user={user_created} />
                    <p className="font-medium">{formatName(user_created)}</p>
                  </>
                ) : (
                  <p className="font-medium text-gray-400">Unknown</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
